import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';
import { CookiesBrowserGuidKey } from './const.js';
import { getCookieRootDomain } from './cookies.js';

const cookies = new Cookies();

export const getBrowserGuid = () => {
  let guid = cookies.get(CookiesBrowserGuidKey);
  if (guid === undefined) {
    guid = uuidv4();
  }

  cookies.set(CookiesBrowserGuidKey, guid, {
    path: '/',
    expires: new Date('9999-12-31T23:59:59'),
    domain: getCookieRootDomain()
  });

  return guid;
};
